import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import menuData from "./menuData";
import "../assets/css/MegaMenu.css";
import { useNavigate } from "react-router-dom";

const getMobileCategories = (data) => {
  const root = data[0];
  const skinCareItems = Object.values(root.megaMenu.left)
    .flat()
    .flatMap((section) => section.items);

  return [
    {
      heading: root.category,
      link: root.link,
      items: skinCareItems,
      isPremium: false,
    },
    ...root.megaMenu.right.map((section) => ({
      heading: section.heading,
      link: section.link,
      items: section.items,
      isPremium: section.heading === "Premium",
    })),
  ];
};

const MobileMegaMenu = ({ onLinkClick, isDrawerOpen }) => {
  const [productsOpen, setProductsOpen] = useState(false);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const categories = getMobileCategories(menuData);

  useEffect(() => {
    if (!isDrawerOpen) {
      setProductsOpen(false);
      setExpandedCategory(null);
    }
  }, [isDrawerOpen]);

  const handleLinkClick = () => {
    if (onLinkClick) onLinkClick();
  };

  const toggleProducts = () => {
    setProductsOpen((prev) => {
      if (prev) setExpandedCategory(null);
      return !prev;
    });
  };

  const toggleCategory = (heading) => {
    setExpandedCategory((prev) => (prev === heading ? null : heading));
  };

  return (
    <div className="mega-menu-container mega-menu-container--mobile mega-menu-container--accordion">
      <button
        type="button"
        className="nav-link mobile-products-trigger"
        onClick={toggleProducts}
        aria-expanded={productsOpen}
        aria-controls="mobile-products-categories"
      >
        <span>Products</span>
        <span className="mobile-accordion-icon" aria-hidden="true">
          {productsOpen ? "▼" : "▶"}
        </span>
      </button>

      <div
        id="mobile-products-categories"
        className={`mobile-accordion-panel mobile-categories-panel ${productsOpen ? "is-open" : ""}`}
      >
        <div className="mobile-accordion-panel-inner">
          <ul className="mobile-category-list">
            {categories.map((category) => {
              const isExpanded = expandedCategory === category.heading;
              const panelId = `mobile-category-${category.heading.replace(/\s+/g, "-").toLowerCase()}`;

              return (
                <li key={category.heading} className="mobile-category-item">
                  <button
                    type="button"
                    className={`mobile-category-trigger ${category.isPremium ? "mobile-category-trigger--premium" : ""} ${isExpanded ? "is-expanded" : ""}`}
                    onClick={() => toggleCategory(category.heading)}
                    aria-expanded={isExpanded}
                    aria-controls={panelId}
                  >
                    <span className={category.isPremium ? "marini-title" : "left-heading"}>
                      {category.heading}
                    </span>
                    <span className="mobile-accordion-icon" aria-hidden="true">
                      {isExpanded ? "▼" : "▶"}
                    </span>
                  </button>

                  <div
                    id={panelId}
                    className={`mobile-accordion-panel mobile-products-panel ${isExpanded ? "is-open" : ""}`}
                  >
                    <div className="mobile-accordion-panel-inner">
                      {category.isPremium ? (
                        <ul className="marini-list mobile-product-list">
                          {category.items.map((item, i) => (
                            <li key={i}>
                              <Link
                                to={item.link}
                                className="marini-item"
                                onClick={handleLinkClick}
                              >
                                {item.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <ul className="mobile-product-list">
                          {category.items.map((item, i) => (
                            <li key={i}>
                              <Link
                                to={item.link}
                                className="mega-link"
                                onClick={handleLinkClick}
                              >
                                {item.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

const DesktopMegaMenu = ({ visible, openMenu, closeMenu, onLinkClick }) => {
  const navigate = useNavigate();
  const productsRef = useRef(null);
  const [arrowLeft, setArrowLeft] = useState(100);

  const skinCareSections = Object.values(menuData[0].megaMenu.left).flat();
  const columns = [];

  for (let i = 0; i < skinCareSections.length; i += 2) {
    columns.push(skinCareSections.slice(i, i + 2));
  }

  const mariniSection = menuData[0].megaMenu.right.find(
    (sec) => sec.heading === "Premium"
  );

  const otherRightSections = menuData[0].megaMenu.right.filter(
    (sec) => sec.heading !== "Premium"
  );

  useEffect(() => {
    const updateArrow = () => {
      if (productsRef.current) {
        const rect = productsRef.current.getBoundingClientRect();
        setArrowLeft(rect.left + rect.width / 2);
      }
    };
    updateArrow();
    window.addEventListener("resize", updateArrow);

    return () => window.removeEventListener("resize", updateArrow);
  }, []);

  const handleLinkClick = () => {
    if (onLinkClick) onLinkClick();
  };

  return (
    <div
      className={`mega-menu-container ${visible ? "visible" : ""}`}
      onMouseEnter={openMenu}
      onMouseLeave={closeMenu}
      style={{
        "--arrow-left": `${arrowLeft}px`,
        pointerEvents: visible ? "auto" : "none",
      }}
      ref={productsRef}
    >
      <div className="mega-menu-inner">

        {/* LEFT */}
        <div className="mega-left">
          <h3
            className="mega-heading-top"
            onClick={() => {
              navigate("/Skin-Care-Products");
              handleLinkClick();
            }}
          >
            Skin Care
          </h3>

          <div className="mega-columns">
            {columns.map((col, idx) => (
              <div className="mega-column" key={idx}>
                {col.map((section, i) => (
                  <div className="mega-section" key={i}>
                    <h4 className="mega-subheading">{section.heading}</h4>
                    <ul>
                      {section.items.map((item, j) => (
                        <li key={j}>
                          <Link
                            to={item.link}
                            className="mega-link"
                            onClick={handleLinkClick}
                          >
                            {item.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT */}
        <div className="mega-right">

          {otherRightSections.map((section, idx) => (
            <div className="mega-section" key={idx}>
              <h6 className="mega-heading left-heading">{section.heading}</h6>
              <ul>
                {section.items.map((item, i) => (
                  <li key={i}>
                    <Link
                      to={item.link}
                      className="mega-link"
                      onClick={handleLinkClick}
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {mariniSection && (
            <div className="marini-block">
              <h5 className="marini-title">Premium</h5>
              <ul className="marini-list">
                {mariniSection.items.map((item, i) => (
                  <li key={i}>
                    <Link
                      to={item.link}
                      className="marini-item"
                      onClick={handleLinkClick}
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

const MegaMenu = ({ visible, openMenu, closeMenu, variant = "desktop", onLinkClick, isDrawerOpen }) => {
  if (variant === "mobile") {
    return <MobileMegaMenu onLinkClick={onLinkClick} isDrawerOpen={isDrawerOpen} />;
  }

  return (
    <DesktopMegaMenu
      visible={visible}
      openMenu={openMenu}
      closeMenu={closeMenu}
      onLinkClick={onLinkClick}
    />
  );
};

export default MegaMenu;
